import React from "react";
import { Segment } from "semantic-ui-react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";

import InventoryList from "InventoryList";

import AdaComponent from "AdaComponent";
import {
  selectServiceError,
  clearServiceErrors,
  opts,
} from "slices/serviceErrorsSlice";
import { hasCapability, CAN_MANAGE_SENSOR_GROUPS } from "slices/userDataSlice";
import {
  // selectHasHierarchy,
  selectOngoing as selectHierarchyOngoing,
  getHierarchy,
} from "slices/hierarchySlice";
import { selectAll as selectSensorGroups } from "slices/sensorGroupsSlice";

import { goTo } from "utils";
import { newSensorGroupTo, sensorGroupTo } from "appRoutes";
import { SENSOR_GROUP_ICON, toIcon } from "icons";

const HIERARCHY = "SensorGroups/hierarchy";

class SensorGroups extends AdaComponent {
  constructor(props) {
    super(props);

    this.setInitialState({});
  }

  componentDidMount() {
    const { hasHierarchy } = this.props;
    if (!hasHierarchy) {
      this.refresh();
    }
  }

  refresh = (reload = false) => {
    const { getHierarchy, t } = this.props;
    getHierarchy(reload, opts(HIERARCHY, t("SensorGroups.refreshError"))).catch(
      (e) => {
        console.error(e);
      }
    );
  };

  clearServiceErrors = () => {
    const { serviceError, clearServiceErrors } = this.props;
    if (serviceError) {
      clearServiceErrors(HIERARCHY);
    }
  };

  handleRefresh = () => {
    this.clearErrors();
    this.clearServiceErrors();
    this.refresh(true);
  };

  handleAdd = () => {
    const { location, history } = this.props;
    goTo(newSensorGroupTo(location), history);
  };

  selectTo = (id) => {
    const { location } = this.props;
    return sensorGroupTo(id, location);
  };

  render() {
    const {
      serviceError,
      getHierarchyOngoing,
      canEdit,
      sensorGroups,
      t,
      i18n: { language },
    } = this.props;

    return (
      <Segment
        as="div"
        className="SensorGroups"
        loading={getHierarchyOngoing}
        data-cy="SensorGroups"
      >
        {this.ErrorMessage()}
        {this.ServiceErrorMessage(serviceError, language)}
        <InventoryList
          items={sensorGroups}
          icon={toIcon(SENSOR_GROUP_ICON)}
          onRefresh={this.handleRefresh}
          refreshText={t("SensorGroups.refresh")}
          onAdd={canEdit && this.handleAdd}
          addText={t("SensorGroups.add")}
          selectTo={this.selectTo}
        />
      </Segment>
    );
  }
}

const mapStateToProps = (state) => ({
  serviceError: selectServiceError(state, HIERARCHY),
  getHierarchyOngoing: selectHierarchyOngoing(state, "getHierarchy"),
  // hasHierarchy: selectHasHierarchy(state),
  canEdit: hasCapability(state, CAN_MANAGE_SENSOR_GROUPS),
  sensorGroups: selectSensorGroups(state),
});

const mapDispatchToProps = {
  getHierarchy,
  clearServiceErrors,
};

export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(SensorGroups))
);
